import LoopFront from "loop-front";
import { TFile } from "../../Components/Input/FileInput";
import { Picture, PictureSize } from "./@types";

const activities = {
    UPLOAD: 'upload'
}

export class PictureModel extends LoopFront<{}, {}, typeof activities> {

    constructor() {
        super('pictures', {}, {}, activities);
    }

    static upload = async (pictureObject: TFile, fileName?: string, folderName?: string) => {
        const { base64, name } = pictureObject;
        return await OPicture.requestPostActivity(OPicture.Activities.UPLOAD, { base64Img: base64, filename: fileName || name, folder: folderName || 'default' }).catch(error => { throw error });
    }

    /**
     * xs: 200,
     * sm: 400,
     * md: 600,
     * lg: 800,
     * xl: 10000
     */
    static getPicUrl = (pic?: Picture, size: PictureSize = 'md'): string => pic ? PictureModel.getTransformedPicture(pic.url, size) : '';

    static getTransformedPicture = (url?: string, size: PictureSize = 'md'): string => `${url}?tr=n-${size}`;


}

export const OPicture = new PictureModel()